import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY, validateEnv } from './env';

// Validate environment variables
if (!validateEnv()) {
  throw new Error('Required environment variables for Supabase are missing');
}

// Create a single supabase client for the entire app
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
